import $ from "jquery";
import Component from "../component/component";
export default class Toggler extends Component {
    constructor($element, config) {
        super($element);
        this.isCollapsed = false;
        this.relatedId = undefined;
        this.$relatedElements = undefined;
        this.$expandIcon = undefined;
        this.$collapseIcon = undefined;
        this.collapseClass = undefined;
        this.toggleMarkup = (isCollapsed) => {
            this.$expandIcon.toggleClass(this.collapseClass, !isCollapsed);
            this.$collapseIcon.toggleClass(this.collapseClass, isCollapsed);
            this.$component.attr("aria-expanded", String(!isCollapsed));
            this.$relatedElements.each((index, relatedElement) => {
                if (isCollapsed) {
                    $(relatedElement).slideUp();
                }
                else {
                    $(relatedElement).slideDown();
                }
                $(relatedElement)
                    .toggleClass(this.collapseClass, isCollapsed)
                    .attr("aria-hidden", isCollapsed.toString());
            });
            window.resizeEvents.globals.currentHeight++;
            $(window).resize();
        };
        this.toggle = this.toggle.bind(this);
        if (this.$component) {
            const options = config || {};
            const { isCollapsed, relatedId, $expandIcon, $collapseIcon, collapseClass, } = options;
            this.isCollapsed =
                isCollapsed || Boolean(this.$component.data("toggle-start-expanded"));
            this.relatedId = relatedId || this.$component.data("toggle-related-id");
            this.$expandIcon =
                $expandIcon || this.$component.find(".js-toggle-expand-icon");
            this.$collapseIcon =
                $collapseIcon || this.$component.find(".js-toggle-collapse-icon");
            this.collapseClass = collapseClass || "u-hidden";
            if (this.relatedId) {
                this.$relatedElements = $('[data-toggle-id="' + this.relatedId + '"]');
                if (this.$relatedElements.length) {
                    this.toggle(this.isCollapsed);
                    this.$component.on("click", (event) => {
                        event.preventDefault();
                        this.isCollapsed = !this.isCollapsed;
                        this.toggle(this.isCollapsed);
                    });
                }
            }
        }
        return this;
    }
    toggle(isCollapsed) {
        this.toggleMarkup(isCollapsed);
        this.emit("toggle", this.relatedId, isCollapsed);
    }
    static init(selector = ".js-toggle") {
        this.enableGlobal();
        const togglerInstances = [];
        $(selector).each((index, element) => {
            const toggler = new Toggler($(element), {
                isCollapsed: true,
                collapseClass: "js-accoridon--toggle",
            });
            togglerInstances.push(toggler);
            toggler.on("toggle", (id, isCollapsed) => {
                if (!isCollapsed) {
                    togglerInstances.forEach((togglerInstance) => {
                        if (togglerInstance.$component[0].hasAttribute("auto-collapse") &&
                            id !== togglerInstance.relatedId) {
                            togglerInstance.isCollapsed = true;
                            togglerInstance.toggleMarkup(true);
                        }
                    });
                }
            });
        });
    }
    static enableGlobal() {
        if (!window["Toggler"]) {
            window["Toggler"] = Toggler;
        }
    }
}
